import axiosInstance from "app/axiosInstance";
import { customerPortal } from "@vilocnv/allsetra-core";

type Icon = customerPortal.icons.Icon;

const getIconsByCategory = async (iconCategory: number): Promise<Icon[]> => {
  try {
    const response = await axiosInstance.get<Icon[]>(
      `/icons/by-category/${iconCategory}`
    );
    if (response.status === 200) {
      return response.data;
    }
    return [];
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};

export default getIconsByCategory;
